<h2 mat-dialog-title>Delete file</h2>
<mat-dialog-content>
  Would you like to delete {{ data.eventName }}?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>No</button>
  <button mat-button (click)="submit()">Ok</button>
</mat-dialog-actions>
